<div *ngIf="loading" class="site-selector-skeleton">
  <div class="skeleton-row" *ngFor="let _ of [1,2,3,4,5]">
    <div class="skeleton-cell checkbox"></div>
    <div class="skeleton-cell wide"></div>
    <div class="skeleton-cell"></div>
    <div class="skeleton-cell"></div>
  </div>
</div>
<table
  [hidden]="loading"
  class="table display site-selector-table"
  #siteSelectorTable
  style="width:100%"
>
  <thead class="table" style="background-color: #FAFAFA;">
    <tr>
      <th></th>
      <th>Site</th>
      <th>City</th>
      <th>State</th>
    </tr>
  </thead>
  <tbody></tbody>
</table>
